export default function styles(theme) {
    return {
      designCard:{
        display: "flex",
        backgroundColor: theme.palette.primary.main,
        border: '1px solid rgba(121, 131, 150, 0.15)',
        padding: 25,
        margin: '0',
        width: "100%",
        borderRadius: 8,
      },
      description: {
        color: theme.palette.text.tertiary,
      },
      svgContainer: {
        width: 'fit-content',
      },
      img: {
        width: "80px !important"
      },
      
      textContainer: {
        display: 'flex',
        gap: 10,
        flexDirection: 'column',
      },
  }
}